export interface OptionDefinition {
  id: string;
  label: string;
  description?: string;
}

// Order mirrors the legacy report: the industry hierarchy and the index columns
// are each kept together.
export const DISPLAY_OPTIONS: OptionDefinition[] = [
  { id: 'displayIsinNumbers',             label: 'Display ISIN Numbers' },
  { id: 'displayIndustry',                label: 'Display Industry' },
  { id: 'displaySuperSector',             label: 'Display Super Sector' },
  { id: 'displaySector',                  label: 'Display Sector' },
  { id: 'displaySubSector',               label: 'Display Sub Sector' },
  { id: 'displayCountry',                 label: 'Display Country' },
  { id: 'displayFirstYearOfMeasurement',  label: 'Display First Year Of Measurement' },
  { id: 'displayIndex1',                  label: 'Display Index 1' },
  { id: 'displayIndex2',                  label: 'Display Index 2' },
  { id: 'displayIndex3',                  label: 'Display Index 3' },
  { id: 'yearOfFounding',                 label: 'Year Of Founding' },
  { id: 'yearWentPublic',                 label: 'Year Went Public' }
];

export const CHECKED_OPTIONS: OptionDefinition[] = [
  { id: 'auditChecked',         label: 'Audit Checked' },
  { id: 'corporateChecked',     label: 'Corporate Checked' },
  { id: 'compensationChecked',  label: 'Compensation Checked' },
  { id: 'csrChecked',           label: 'ESG Checked' },
  { id: 'accountingChecked',    label: 'Accounting Checked' }
];

export const EXPORT_OPTIONS: OptionDefinition[] = [...DISPLAY_OPTIONS, ...CHECKED_OPTIONS];

export type DataKind = 'company' | 'director' | 'voting-results';

// Step-5 tabs per data-kind. Each tab merges one or more backend categories;
// by default, each source category becomes its own section inside the tab.
// `sectionsByTitle` overrides that with an explicit, title-based split — the
// listed titles are looked up across every category the customer has access to.
export interface VariableTabDefinition {
  name: string;
  categories: readonly string[];
  sectionsByTitle?: readonly { name: string; titles: readonly string[] }[];
}

export const TABS_PER_KIND: Record<DataKind, readonly VariableTabDefinition[]> = {
  company: [
    { name: 'Corporate Governance', categories: ['Board', 'Committees'] },
    { name: 'Ownership',            categories: ['Ownership'] },
    { name: 'Family Firms',         categories: ['Family Firms'] },
    { name: 'Compensation',         categories: ['Compensation'] },
    { name: 'Audit',                categories: ['Audit'] },
    { name: 'ESG',                  categories: ['Society', 'Environment', 'Employees'] },
    { name: 'Financial',            categories: ['Financial Indicators'] }
  ],
  director: [
    { name: 'Directors',              categories: ['Directors'] },
    { name: 'Directors Compensation', categories: ['Directors Compensation'] }
  ],
  'voting-results': [
    { name: 'Voting Results', categories: ['Voting Results'] }
  ]
};

// Backend category names accepted by each customer report endpoint. Derived from
// TABS_PER_KIND so the tab grouping is the single source of truth.
export const CATEGORIES_PER_KIND: Record<DataKind, ReadonlySet<string>> = {
  company:          new Set(TABS_PER_KIND.company.flatMap(t => t.categories)),
  director:         new Set(TABS_PER_KIND.director.flatMap(t => t.categories)),
  'voting-results': new Set(TABS_PER_KIND['voting-results'].flatMap(t => t.categories))
};
